<template>
  <div>
    <loading-full v-if="processing" :status="statusmensagem" />

    <div class="card">
      <div class="card-header">
        <div class="name f3 fw8 w-100 ml-2">Pagamento</div>
      </div>

      <div class="card-body">
        <div v-if="this.error" class="alert alert-danger" style="position:sticky;top:1em;z-index:1000;">
         {{ this.error }}
        </div>

        <div v-if="orderPaymentStatus == 'payed'">
          <div class="alert alert-success">
            <h5>Pagamento Confirmado!</h5>
          </div>
        </div>

        <div v-if="orderPaymentStatus != 'payed'">
          <div class="alert alert-warning" v-if="orderPaymentStatus == 'waiting'">
            <h5>
              Aguardando confirmação do pagamento! <br />
              <small>Se pagou via boleto, aguarde até 3 dias úteis!</small>
            </h5>
          </div>
          <h6 v-if="orderPaymentStatus == 'waiting'">
            Se desejar efetuar uma nova forma de pagamento, escolha abaixo:
          </h6>

          <h5 v-else>Escolha sua forma de pagamento:</h5>

          <payment-options-select v-if="amount > 0"></payment-options-select>
          <div v-if="amount == 0">-- Não é necessário --</div>
          <!-- payment-{{paymentOptionSelected.providerId}} -->

          <component
            v-if="paymentOptionSelected.providerId"
            :paymentOption="paymentOptionSelected"
            :amount="amount"
            v-model="paymentInfo"
            ref="paymentSelected"
            :is="'payment-' + paymentOptionSelected.providerId"
          ></component>
        </div>

        <div
          v-if="
            this.$route.params.order != undefined &&
            orderPaymentStatus != 'waiting' &&
            orderPaymentStatus != 'payed'
          "
          class="mt-4 mb-2 alert alert-info"
        >
          Você pode acessar esse pedido a qualquer momento utilizando o link
          <a :href="location">{{ location }}</a> para finalizar o pagamento!
        </div>

        <!-- <div v-if="this.error" class="alert alert-danger">
          {{ this.error }}
        </div> -->
      </div>
    </div>
  </div>
</template>

<script>
import validadeFormMixins from "@/mixins/validateForms"
export default {
    mixins: [validadeFormMixins],
    data() {
        return {
            // paymentInfo:{
            //     info:{},
            //     selectedOption:{},
            // },
            error: false,
            erromsg: '',
            erroinpayment: false,
            paymenterror: false,
            ordertoken: false,
            processing: false,
            statusmensagem: ''
        }
    },

    mounted() {

    },

    watch: {
        paymentOptionSelected: function () {
            if (this.error == "Selecione uma forma de pagamento") {
                this.error = false
            }
        },
    },

    computed: {
        orderPaymentStatus: function () {
            return this.$store.getters['OrderStore/currentOrderPaymentStatus']
        },
        buyerInfo: {
            set: function (val) {
                this.$store.commit('OrderStore/updateBuyer', val)
            },
            get: function (val) {
                return this.$store.getters['OrderStore/buyer']
            }
        },
        paymentInfo: {
            set: function (val) {
                this.$store.commit('OrderStore/updatePaymentInfo', val)
            },
            get: function (val) {
                return this.$store.getters['OrderStore/paymentInfo']
            }
        },
        paymentOptionSelected: {
            set: function (val) {
                //debugger;
                this.$store.commit('OrderStore/paymentOptionSelected', val)
                if (!this.$route.params.order) {
                    this.$nextTick(() => this.saveOrderWithoutPayment())

                }
            },
            get: function () {
                return this.$store.getters['OrderStore/paymentOptionSelected'];
            }
        },
        amount: function () {
            return this.$store.getters['OrderStore/getTotalFinal']
        },
        location: function () {
            return window.location.href;
        }
    },

    methods: {
        change: function () {

        },

        saveOrderWithoutPayment: async function () {

            this.statusmensagem = "Processando..."
            this.processing = true;
            this.paymenterror = false;
            var formValid = await this.validateForms();

            if (formValid) {
                this.statusmensagem = "Salvando pedido..."
                var response = await this.$store.dispatch('OrderStore/placeOrder', { buyer: {}, paymment: {} })
                let order = response.order;

                //erro para salvar a order   
                if (response.error) {
                    this.error = response.msg;
                    this.processing = false;
                    return false;

                }
                this.processing = false;
                this.statusmensagem = ""
                if (order.token) {
                    this.ordertoken = order.token
                    this.$router.replace({ params: { order: order.token } })
                }
            }
        },

        formsOk:async function(){
            return await this.validateForms();
         
        },

        placeOrder: async function () {

           


            var formValid = await this.validateForms();

            if(!formValid){
                return false;
            }

            //check if have paymento method selected
            if (_.isEmpty(this.paymentOptionSelected) && this.amount > 0) {
                this.error = "Selecione uma forma de pagamento"
                return false;
            }


            this.processing = true;
            this.statusmensagem = "Processando..."



            // if( this.$refs.paymentSelected ){
            //     this.statusmensagem = "Validando dados de pagamento..."
            //     let paymentSelectOk = await this.$refs.paymentSelected.validate();
            //     if(!paymentSelectOk){
            //         this.processing = false;
            //         return false;

            //     }
            // }

            this.paymenterror = false;
            if (formValid) {
                this.statusmensagem = "Enviando pagamento..."
                var response = await this.$store.dispatch('OrderStore/placeOrder', { buyer: this.buyerInfo, paymment: this.buyerInfo })
                let order = response.order;
                
                //erro para salvar a order   
                if (response.error) {
                    
                    this.error = response.msg;
                    this.processing = false;
                    return false;

                }

                // erro no pagamento
                if (_.get(response, 'payment.error', false)) {
                    let erromsg = "Erro no pagamento:\n"
                    this.paymenterror = true;

                    let erros = _.get(response, 'payment.message')
                    if (_.isArray(erros)) {
                        _.each(response.payment.message.errors.error, e => erromsg += _.get(e, 'message'))
                    } else {
                        erromsg += _.get(erros, 'message', erros)
                    }
                    this.error = erromsg;
                }

                this.processing = false;
                this.statusmensagem = ""
                if (order.token) {

                    if (this.paymenterror == false) {
                        this.$router.replace(`/order/${order.token}`)
                        // setTimeout( ()=> window.location.reload(), 10)
                    } else {
                        this.ordertoken = order.token
                        this.$router.replace({ params: { order: order.token } })
                    }
                }
            }
        }
    }

}
</script>

<style></style>
